import { render } from "./ApplicationTypeChart.vue?vue&type=template&id=5d2bed38"
import script from "./ApplicationTypeChart.vue?vue&type=script&lang=js"
export * from "./ApplicationTypeChart.vue?vue&type=script&lang=js"
script.render = render

export default script